import { route } from 'preact-router'

interface LinkButtonProps {
  to: string
  children: string
}

export function LinkButton({ to, children }: LinkButtonProps) {
  const handleClick = () => {
    route(to)
  }

  return (
    <button
      onClick={handleClick}
      className="px-2 py-1 md:px-3 md:py-1.5 text-xs md:text-sm font-medium text-slate-400 hover:text-white hover:bg-slate-700 rounded-md transition-colors"
    >
      {children}
    </button>
  )
}
